// extracted by mini-css-extract-plugin
export default {"my-list":"list_my-list__j6ue-"};